import { createSystem, defaultConfig } from '@chakra-ui/react';

import foundationConfigs from './foundations';
import recipeConfigs from './recipes';

const system = createSystem(defaultConfig, ...foundationConfigs, ...recipeConfigs);
export default system;
